export * from "-!../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loader.vue?vue&type=template&id=4aba0168&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/PhotoEditor/components/loader.vue?vue&type=template&id=4aba0168&scoped=true
// module id = 1397
// module chunks = 31